"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var effects_1 = require("@ngrx/effects");
var store_1 = require("@ngrx/store");
var skynet_store_manager_1 = require("@synisys/skynet-store-manager");
var skynet_store_messages_api_1 = require("@synisys/skynet-store-messages-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var Observable_1 = require("rxjs/Observable");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var async_1 = require("rxjs/scheduler/async");
var noop_1 = require("rxjs/util/noop");
var messages_utilities_1 = require("../messages.utilities");
var message_service_1 = require("../services/message.service");
var logger = messages_utilities_1.createLogger('message-effects');
var MessageEffects = /** @class */ (function () {
    function MessageEffects(actions$, store, messageService, ngZone) {
        var _this = this;
        this.actions$ = actions$;
        this.store = store;
        this.messageService = messageService;
        this.ngZone = ngZone;
        this.loadMessage$ = this.actions$.pipe(effects_1.ofType(skynet_store_messages_api_1.messageStoreManager.actionType(skynet_store_manager_1.StandardActionTypes.LOAD_ONE)), operators_1.bufferTime(1000, -1, 50, skynet_store_utilities_1.leaveZone(this.ngZone, async_1.async)), operators_1.observeOn(skynet_store_utilities_1.enterZone(this.ngZone, async_1.async)), operators_1.filter(function (value) { return value && value.length > 0; }), operators_1.map(function (actions) {
            return immutable_1.Set(actions.map(function (action) { return action.id; }));
        }), operators_1.mergeMap(function (actions) {
            return _this._loadedMessages$.pipe(operators_1.first(), operators_1.map(function (messages) {
                return MessageEffects_1.filterMessages(messages, actions);
            }), operators_1.map(function (notLoadedKeys) { return notLoadedKeys.groupBy(function (k) { return k.languageId; }); }));
        }), operators_1.mergeMap(function (notLoadedKeysByLanguage) {
            if (!notLoadedKeysByLanguage.isEmpty()) {
                return zip_1.zip.apply(void 0, notLoadedKeysByLanguage
                    .entrySeq()
                    .map(function (_a) {
                    var language = _a[0], keys = _a[1];
                    return _this.messageService.loadMessages(language, keys
                        .map(function (key) { return key.name; })
                        .filter(lodash_1.negate(lodash_1.isEmpty))
                        .join(','));
                })
                    .toArray()).pipe(operators_1.map(function (rawMessages) {
                    var tempMap = immutable_1.Map();
                    return tempMap.withMutations(function (mutable) {
                        rawMessages.forEach(function (msgs) {
                            msgs.forEach(function (msg) { return mutable.set(msg.key, msg); });
                        });
                    });
                }), operators_1.map(function (messages) {
                    return skynet_store_messages_api_1.messageStoreManager.createAction(skynet_store_manager_1.StandardActionTypes.LOAD_MANY_SUCCESS, messages);
                }), operators_1.catchError(function (err) {
                    return of_1.of(skynet_store_messages_api_1.messageStoreManager.createAction(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR, new skynet_store_utilities_1.StoreManagerError(err, 'could not load messages')));
                }));
            }
            else {
                return of_1.of(skynet_store_messages_api_1.messageStoreManager.createAction(skynet_store_manager_1.StandardActionTypes.LOAD_MANY_SUCCESS, undefined));
            }
        }));
        this.printError = this.actions$.pipe(effects_1.ofType(skynet_store_messages_api_1.messageStoreManager.actionType(skynet_store_manager_1.StandardActionTypes.ENTITY_ERROR)), operators_1.map(function (action) {
            if (lodash_1.get(action.error, 'type') === 'StoreManagerError') {
                skynet_store_utilities_1.logStoreError(action.error, logger);
            }
            else {
                logger.error('error while loading: error => \n %o', action.error);
            }
        }), operators_1.tap(noop_1.noop, function (e) { return logger.error(e); }));
        this._loadedMessages$ = this.store.select(function (state) { return state.messages.data; });
    }
    MessageEffects_1 = MessageEffects;
    MessageEffects.filterMessages = function (loadedMessages, requestedKeys) {
        var predicate = function (key) { return loadedMessages.has(key); }; // for ngc
        return requestedKeys.filterNot(predicate);
    };
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], MessageEffects.prototype, "loadMessage$", void 0);
    __decorate([
        effects_1.Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], MessageEffects.prototype, "printError", void 0);
    MessageEffects = MessageEffects_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [effects_1.Actions,
            store_1.Store,
            message_service_1.MessageService,
            core_1.NgZone])
    ], MessageEffects);
    return MessageEffects;
    var MessageEffects_1;
}());
exports.MessageEffects = MessageEffects;
//# sourceMappingURL=message.effects.js.map